import Page from 'component/Page';
import { useEffect, useMemo, useState } from 'react';
import { sendPost, sendDelete } from 'util/request';
import string from 'util/string';
import Urls from 'util/urls';
import Table from 'component/Table';
import Modal from 'component/Modal';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from 'redux/user/user.selector';
import { useHistory } from 'react-router-dom';
import { ACCOUNT_ROLE_ADMIN } from 'util/permission';
import { useCallback } from 'react';
// import { selectSearchRangeDate } from 'redux/app/app.selector';
import {
	nNU,
	formatDate,
	formatLocalDate,
	showConfirm,
	showToast,
	formatMinutes,
	getServiceCode
} from 'util/utils';
import Paths from 'util/paths';
import ServiceCodeAdd from './ServiceCodeAdd';
import ServiceCodeActivate from './ServiceCodeActivate';

const ServiceCodeList = () => {
	//-------------------------------HOOKS-------------------------------------------------------------
	const currentUser = useSelector(selectCurrentUser);
	const [ serviceCode, setServiceCode ] = useState([]);
	// const searchRangeDate = useSelector(selectSearchRangeDate);
	const [ addCode, setAddCode ] = useState(null);
	const [ activateCode, setActivateCode ] = useState(null);
	const [ page, setPage ] = useState(1);
	const [ total, setTotal ] = useState(0);
	const [ pageSize, setPageSize ] = useState(10);
	const isAdmin = useMemo(
			() => currentUser.accountRole === ACCOUNT_ROLE_ADMIN,
			[ currentUser.accountRole ]
	);
	const headers = isAdmin ? [
		string.APP_ADMIN_SC_STR,
		string.APP_ADMIN_SC_VOL,
		string.APP_ADMIN_SC_USED,
		string.APP_ADMIN_SC_REMAIN,
		string.APP_ADMIN_SC_ADDED_BY,
		string.APP_ADMIN_SC_ADDED_DATE,
		string.APP_ADMIN_SC_ACTIVATED_BY,
		string.APP_ADMIN_SC_ACTIVATED_DATE,
	] : [
		string.APP_USER_SC_STR,
		string.APP_USER_SC_VOL_TOTAL,
		string.APP_USER_SC_VOL_USED,
		string.APP_USER_SC_VOL_REMAIN,
		string.APP_USER_SC_ACTIVATED_DATE,
	];
	const isMonitorOnly = useMemo(
		() => currentUser.isMonitorOnly === 1,
		[currentUser.isMonitorOnly]
	);
	const [ searchId, setSearchId ] = useState('');
	const [ debouncedSearchId, setDebouncedSearchId ] = useState(searchId);
	const [ selectCode, setSelectCode ] = useState(null);
	const [ deleteCode, setDeleteCode ] = useState(null);
	const history = useHistory();
	// const [ searchData, setSearchData ] = useState({
	//     fromDate: searchRangeDate?.[ 0 ] || truncTime(adjustDate(new Date(), -7)),
	//     toDate: searchRangeDate?.[ 1 ] || truncTime(),
	// });

	//------------------------------FUNCTIONS----------------------------------------------------------

	const doSearch = useCallback(
		async (page, pageSize, searchKeyword, getAll = false) => {
			let data = await sendPost({
				url: isAdmin ? Urls.servicecode.list : Urls.servicecode.user,
				body: {
					userId: currentUser.id,
					offset: (page - 1) * pageSize,
					size: pageSize,
					keyword: searchKeyword,
				},
			});
			const { total, result } = data;
			if (!getAll) {
				setServiceCode(result);
				setTotal(total);
			}
			return result;
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[ currentUser, deleteCode ]
	);
	useEffect(() => {
		const timerId = setTimeout(() => {
			setDebouncedSearchId(searchId);
		}, 500);
		return () => {
			clearTimeout(timerId);
		};
	}, [ searchId ]);
	useEffect(() => {
			doSearch(page, pageSize, debouncedSearchId);
	}, [ page, pageSize, debouncedSearchId, doSearch ]);
	const dataTable = useCallback(
		(data) => data.map((raw, key) => ({
			key: raw.id,
			data: isAdmin ? [
				getServiceCode(raw?.code),
				raw?.volume,
				nNU(raw?.volumeUsage) ? raw?.volumeUsage : 0,
				nNU(raw?.volumeUsage) ? (raw?.volume - raw?.volumeUsage) : raw?.volume,
				raw?.createdByEmail,
				formatDate(raw?.createdAt, 'YYYY/MM/DD'),
				raw?.activatedByEmail,
				formatDate(raw?.activatedAt, 'YYYY/MM/DD'),
			] : [
				getServiceCode(raw?.code),
				raw?.volume,
				nNU(raw?.volumeUsage) ? raw?.volumeUsage : 0,
				nNU(raw?.volumeUsage) ? (raw?.volume - raw?.volumeUsage) : raw?.volume,
				formatDate(raw?.activatedAt, 'YYYY/MM/DD'),
			],
			raw,
		})),
		[]
	);
	const mainActions = !isAdmin ? [
		{ icon: 'add', title: string.APP_USER_SC_ACTIVATE, onClick: () => setActivateCode({ valid: true })},
	] : isMonitorOnly ? []: [
		{ icon: 'add', title: string.APP_ADMIN_SC_ADD, onClick: () => setAddCode({ valid: true })},
	];
	const actions = !isAdmin ? [
		({raw}) => {
			if(nNU(raw.id)){
				return { render: 'edit', onClick: ({ raw }) => setSelectCode(raw) };
			}
		},
	] : isMonitorOnly ? [
		({raw}) => {
			if(nNU(raw.activatedId)){
				return { render: 'info', onClick: ({ raw }) => setSelectCode(raw) };
			}
		},
	]:[
		({raw}) => {
			if(nNU(raw.activatedId)){
				return { render: 'info', onClick: ({ raw }) => setSelectCode(raw) };
			}
		},
		({raw}) => {
			if(!nNU(raw.activatedId)){
				return { render: 'delete',className: 'color-danger', onClick: ({ raw }) => setDeleteCode(raw) };
			}
		},
	];
	useEffect(() => {
		// console.log(selectCode?.id);
		if(isAdmin) {
			if(nNU(selectCode?.activatedId)){
				history.push(`${Paths.servicecode.assign}/?id=${selectCode?.activatedId}`);
			}
		} else {
			if(nNU(selectCode?.id)){
				history.push(`${Paths.servicecode.assign}/?id=${selectCode?.id}`);
			}
		}
	},[selectCode]);
	useEffect(()=>{
		if(!nNU(deleteCode)){
			return;
		}
		if(!isAdmin){
			setDeleteCode(null);
			return;
		}
		if(isMonitorOnly){
			setDeleteCode(null);
			return;
		}
		showConfirm({
			body: string.APP_SC_DELETE_CONFIRM,
			defaultAction: () => {
				sendDelete({
					url: `${Urls.servicecode.delete}/${deleteCode?.id}`,
				}).then((res) => {
					showToast(string.APP_SC_DELETE_SUCCESS, 'success');
					setDeleteCode(null);
					// window.location.reload();
				}).catch((e) => {

				});
			},
		});
	},[deleteCode]);

	//-------------------------------RETURN------------------------------------------------------------
	return (
		<>
			<Page
				title={string.APP_ADMIN_SERVICE_CODE_TITLE}
				body={
					<>
						<Table
							className="nowrap"
							page={page}
							pageSize={pageSize}
							total={total}
							onPageChanged={setPage}
							onPageSizeChanged={setPageSize}
							headers={headers}
							data={dataTable(serviceCode)}
							getCSVData={!isMonitorOnly && (async () => {
								return dataTable(await doSearch(1, total, null, true));
							})}
							csvFileName="ServiceCodeList"
							isPaging={true}
							mainActions={mainActions}
							actions={actions}
							// search={true}
							onSearch={(value) => setSearchId(value)}
							// placeHolder={string.LOGIN_ID}
						/>
					</>
				}
			/>
			<Modal
				show={!!addCode}
				onHide={() => setAddCode(null)}
				body={
					<>
						{!!addCode && (
							<ServiceCodeAdd
								onUpdated={() => {
									setAddCode(null);
									doSearch(page, pageSize);
								}}
								data={addCode}
							/>
						)}
					</>
				}
			/>
			<Modal
				show={!!activateCode}
				onHide={() => setActivateCode(null)}
				body={
					<>
						{!!activateCode && (
							<ServiceCodeActivate
								onUpdated={() => {
									setActivateCode(null);
									doSearch(page, pageSize);
								}}
								data={activateCode}
							/>
						)}
					</>
				}
			/>
		</>
	);
};

export default ServiceCodeList;
